import {Redirect} from 'react-router-dom';
import Login from './Login';

export const authRoute = {path: '/login', name: 'Login', Component: Login};

// L'inscription en ligne est fermée : les comptes sont créés par les commerciaux.
export const registerRedirectRoute = {
  path: '/register',
  name: 'RegisterRedirect',
  Component: () => <Redirect to="/login" />,
};
